const AUTH_TOKEN_KEY = 'spiderAuthToken'

export class StateLoader {
	static loadState() {
		try {
			let serializedState = sessionStorage.getItem('spiderState')

			if (serializedState === null) {
				return this.initializeState()
			}

			return JSON.parse(serializedState)
		} catch (err) {
			return this.initializeState()
		}
	}

	static saveState(state) {
		try {
			let serializedState = JSON.stringify(state)
			// let serializedState = state
			sessionStorage.setItem('spiderState', serializedState)
		} catch (err) {
			console.error('saveState Error: ', err)
		}
	}

	static loadToken() {
		try {
			return sessionStorage.getItem(AUTH_TOKEN_KEY)
		} catch (err) {
			return null
		}
	}

	static saveToken(token) {
		try {
			sessionStorage.setItem(AUTH_TOKEN_KEY, token)
		} catch (err) {
			console.error('saveToken Error: ', err)
		}
	}

	// 로그아웃, 인증 만료 시 세션 정보 삭제
	static clear() {
		try {
			sessionStorage.removeItem(AUTH_TOKEN_KEY)
			sessionStorage.removeItem('spiderState')
		} catch (err) {
			console.error('clear Error: ', err)
		}
	}

	static initializeState() {
		return {
			//state object
			isLoggedIn: false,
			user: {
				id: '',
				groupCode: '',
				loginTime: '',
				p_code: null,
				p_name: null,
			},
			menus: [],
		}
	}
}
